<template>
  <div class="content-container">
    <!-- Search Component -->
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row" style="align-items: flex-end">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('field.groupCodeOrGroupPackName') }}
                </div>
                <div class="child-w-80">
                  <input v-model="searchParams.keyword" type="text" />
                </div>
              </div>
            </div>
            <!-- <div class="das-form-col col-4">
              <div class="das-form-input">
                <div>
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp3"
                      v-model="searchParams.showInactivePack"
                      type="checkbox"
                    />
                    <label for="cpSpdTp3">
                      {{ $t('field.showInactivePackGroup') }}
                    </label>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('views.configuration.showPackageGroup') }}
                </div>
                <el-select v-model="searchParams.active" placeholder="">
                  <!-- @change="attachData" -->
                  <el-option
                    v-for="item in packGroupActiveOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="grid-scroll das-layout">
      <div class="l-w-60 flex flex-col">
        <div v-loading="packageGridLoading" class="grid-scroll">
          <GridVx
            ref="packageGrid"
            :columns="packageGroupCols"
            :rows="packageGroupRows"
            class="agGrid"
            @refresh="onRefresh"
            @selectionChanged="onSelectPackageGroup"
          />
        </div>
        <div class="grid-bottom">
          <GridPaging
            target="packageGrid"
            :total-size="totalPage"
            :page-num="currentPage"
            @pageChanged="onPageChanged"
            @onPageSizeChange="onPageSizeChange"
          />
        </div>
      </div>
      <div class="l-w-40">
        <GridVx
          ref="agGrid"
          :columns="packageCols"
          :rows="packageRows"
          :auto-select-first-row="false"
          class="agGrid"
          @refresh="onRefresh"
        />
      </div>
    </div>
    <div class="button-containers mb-0">
      <button class="btn primary small outline" @click="deletePackageGroup">
        {{ $t('button.deletePackageGroup') }}
      </button>
      <button class="btn primary small" @click="fnOpenEditDialog">
        {{ $t('button.modifyPackageGroup') }}
      </button>
      <button class="btn primary small" @click="fnOpenAddDialog">
        {{ $t('button.addPackageGroup') }}
      </button>

      <!-- <button class="btn primary small outline">Sửa thuế</button> -->
    </div>
    <el-dialog
      :title="
        isEditDialog
          ? $t('dialog.titlePackageGroupModify')
          : $t('dialog.titlePackageGroupAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="1000px"
    >
      <!-- START FORM -->
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.packGroupCode') }}
                  </div>
                  <validation-provider
                    rules="required|max:20|no_special"
                    :name="$t('field.packGroupCode')"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="formPackGroup.code"
                        :disabled="isEditDialog"
                        type="text"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.packGroupName') }}
                  </div>
                  <validation-provider
                    rules="required|max:50"
                    :name="$t('field.packGroupName')"
                  >
                    <div class="child-w-80">
                      <input v-model="formPackGroup.name" type="text" />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.minPeopleAmount') }}
                  </div>
                  <validation-provider
                    rules="required|number|min_value:0|max_value:100"
                    :name="$t('field.minPeopleAmount')"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="formPackGroup.min_apply_people"
                        v-numeric-only
                        type="text"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.maxPeopleAmount') }}
                  </div>
                  <validation-provider
                    rules="required|number|min_value:0|max_value:100"
                    :name="$t('field.maxPeopleAmount')"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="formPackGroup.max_apply_people"
                        v-numeric-only
                        type="text"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <validation-provider rules="max:200" :name="$t('field.desc')">
                    <div class="label">
                      {{ $t('field.desc') }}
                    </div>
                    <textarea
                      v-model="formPackGroup.description"
                      style="width: 100%"
                      rows="2"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="checkbox-container">
                  <div class="checkbox-wrap">
                    <input
                      id="sold_individually"
                      v-model="formPackGroup.sold_individually"
                      type="checkbox"
                    />
                    <label for="sold_individually">
                      {{ $t('field.enableSaleIndividually') }}
                    </label>
                  </div>
                  <div class="checkbox-wrap">
                    <!-- <div class="label" style="margin-right: 5px">
                      {{ $t('field.active') }}
                    </div>
                    <el-switch
                      v-model="formPackGroup.active"
                      active-color="#357456"
                      inactive-color="#CAC9C9"
                    /> -->
                    <input
                      id="active"
                      v-model="formPackGroup.active"
                      type="checkbox"
                    />
                    <label for="active">
                      {{ $t('field.enableSaleIndividually') }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <div class="das-form-container">
        <div class="das-form-title-container">
          <div class="das-form-title">
            <span class="main-title p-0">{{
              $t('dialog.findAndSelectPackForPackGroup')
            }}</span>
          </div>
        </div>
        <div class="das-form-group">
          <div class="das-form-row align-end">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.packageCodeName') }}</div>
                <div class="child-w-80">
                  <input v-model="packageSearchParams.keyword" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <button class="btn primary small" @click="fnSearchUnAttachedPack">
                {{ $t('button.search') }}
              </button>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('field.roomLevel') }}
                </div>
                <div class="child-w-80">
                  <el-select
                    v-model="formPackGroup.room_level_ids"
                    multiple
                    collapse-tags
                    placeholder=""
                  >
                    <el-option
                      v-for="option in roomLevelOptions"
                      :key="option.id"
                      :label="option.name"
                      :value="option.id"
                    />
                  </el-select>
                </div>
              </div>
            </div>
            <!-- ticket type -->
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('field.ticketType') }}
                </div>
                <div class="child-w-80">
                  <el-select
                    v-model="formPackGroup.ticket_type_id"
                    collapse-tags
                    placeholder=""
                  >
                    <el-option
                      v-for="option in ticketTypeOptions"
                      :key="option.id"
                      :label="option.code"
                      :value="option.id"
                    />
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="das-form-container">
        <div class="das-form-title-container">
          <div class="das-form-title">
            <!-- <span class="main-title p-0">DANH SÁCH GÓI CHƯA CHỌN</span> -->
          </div>
        </div>
        <MultiGridsTransfer
          :key="multiGridTransKey"
          :title1="$t('dialog.unselectedPackList')"
          :title2="$t('dialog.selectedPackList')"
          :columns1="attachedPackRowCols"
          :rows1="unAttachedPackRow"
          :columns2="attachedPackRowCols"
          :rows2="attachedPackRow"
          @transferData="updateAttachedPack"
        />
      </div>

      <!-- END FORM -->

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small outline" @click="fnCancelDialog">
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEditDialog"
            class="btn primary small"
            @click="updatePackageGroup"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addPackageGroup">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import bus from '@/utils/bus'
/* eslint-disable */
import GridWithChoice from '@/components/grid/GridWithChoice.vue'
import MultiGridsTransfer from '@/components/grid/MultiGridsTransfer.vue'
import { getPackageApi } from '@/api/Service_Policy/package'
import {
  getPackageGroupApi,
  getPackageGroupDetailApi,
  deletePackageGroupApi,
  updatePackageGroupApi,
  addPackageGroupApi
} from '@/api/Service_Policy/PackageGroup'
import { getAllRoomLevelApi, getTicketTypeApi } from '@/api/Room/roomLevel'
import { Message } from 'element-ui'
import { CellRenderToggleSwitchReadOnly } from '@/utils/cellRenders.js'
import { assignObjectFields } from '@/utils/form'

export default {
  components: {
    CellRenderToggleSwitchReadOnly,
    GridWithChoice,
    MultiGridsTransfer
  },
  data() {
    return {
      packageGridLoading: false,
      formPackGroup: {
        id: null,
        code: '',
        name: '',
        description: '',
        sold_individually: true,
        active: true,
        package_id_list: [],
        max_apply_people: null,
        min_apply_people: null
      },
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEditDialog: false,
      dialogFormVisible: false,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        orderTp: 'ASC',
        orderBy: 'code',
        keyword: '',
        // showInactivePack: false,
        active: null
      },
      packageSearchParams: {
        keyword: null
      },
      packageGroupCols: [
        {
          headerdesc: '',
          // field: "index",
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('grid.column.packageGroupCode'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          width: 120,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.packageGroupName'),
          field: 'name',
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          minWidth: 200,
          sortable: false,
          flex: 1
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.active'),
          field: 'active',
          cellRenderer: 'CellRenderToggleSwitchReadOnly',
          cellRendererParams: params => {
            return {
              active: params.data.active
            }
          },
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          maxWidth: 100,
          sortable: false
        }
      ],
      packageCols: [
        {
          headerName: this.$t('grid.column.packageCode'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.packageName'),
          field: 'name',
          // cellClass: "grid-cell-centered",
          width: 200,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.startSaleDate'),
          field: 'start_date',
          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.endSaleDate'),
          field: 'end_date',
          sortable: false
          // cellClass: "grid-cell-centered",
        }
      ],
      attachedPackRowCols: [
        {
          headerdesc: '',
          // field: "index",
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.packageCode'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          sort: 'asc'
        },
        {
          headerName: this.$t('grid.column.packageName'),
          field: 'name',
          // cellClass: "grid-cell-centered",,
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.startSaleDate'),
          field: 'start_date',
          // cellClass: "grid-cell-centered",,
          minWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.endSaleDate'),
          field: 'end_date',
          // cellClass: "grid-cell-centered",,
          minWidth: 150,
          sortable: false
        }
      ],
      packageGroupRows: [],
      packageRows: [],
      unAttachedPackRow: [],
      attachedPackRow: [],
      packGroupActiveOptions: [
        {
          value: null,
          label: this.$t('variables.all')
        },
        {
          value: '10',
          label: this.$t('variables.active')
        },
        {
          value: '20',
          label: this.$t('variables.nonActive')
        }
      ],
      roomLevelOptions: [],
      ticketTypeOptions: [],
      multiGridTransKey: 1000
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible
        ? null
        : setTimeout(() => {
            this.resetPackGroupDialog()
          }, 500)
    }
  },

  mounted() {
    this.attachData()
    this.getPackageList({ isAttachPack: false })

    // GRID
    this.packageGridApi = this.$refs.packageGrid.gridApi
    this.fnGetRoomLevelOptions()
    this.fnGetTicketTypeOptions()
  },
  methods: {
    onSearch() {
      this.searchParams.pageNum = 1
      this.attachData()
    },
    onReset() {
      this.searchParams = {
        ...this.searchParams,
        orderTp: 'ASC',
        orderBy: 'code',
        keyword: '',
        // showInactivePack: false,
        active: null,
        pageNum: 1
      }
      this.attachData()
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },
    async attachData() {
      this.packageGridLoading = true
      // const searchParams = {
      //   ...this.searchParams,
      //   active: this.searchParams.showInactivePack ? null : 10
      // }
      let data = await getPackageGroupApi(this.searchParams)
      this.packageGroupRows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length == 0 ? 0 : data.page_num
      this.packageGridLoading = false
    },
    async getPackageList({ isAttachPack = false }) {
      let packageList
      try {
        packageList = await getPackageApi({
          isExpired: true,
          isNonActive: true
        }).then(res => res.data)
      } catch (err) {
        this.$message({ type: 'error', message: err.response.data.message })
        return
      }
      if (!isAttachPack) {
        this.unAttachedPackRow = [...packageList]
      } else {
        const packSelected = this.packageGridApi.getSelectedRows()?.[0]
        if (packSelected) {
          this.attachedPackRow = [...packSelected.packages]
          this.unAttachedPackRow = packageList.filter(
            item => !packSelected.packages?.some(d => d.id === item.id)
          )
        }
      }
    },

    async fnSearchUnAttachedPack() {
      let packageList
      try {
        packageList = await getPackageApi({
          keyword: this.packageSearchParams.keyword,
          isExpired: true,
          isNonActive: true
        }).then(res => res.data)

        this.unAttachedPackRow = packageList.filter(
          item => !this.attachedPackRow?.some(d => d.id === item.id)
        )
      } catch (err) {
        this.$message({ type: 'error', message: err.response.data.message })
        return
      }
    },

    nextToChoice(data) {
      // const gridApi = this.$refs.agGridPackage.gridApi;
      // const rowsSelected = gridApi.getSelectedRows();
      this.unAttachedPackRow = data.row1
      this.attachedPackRow = data.row2
      this.formPackGroup.package_id_list = this.attachedPackRow.map(s => s.id)
    },
    undoChoice(data) {
      // const gridApi = this.$refs.agGridPackageChoice.gridApi;
      // const rowsSelected = gridApi.getSelectedRows();
      this.unAttachedPackRow = data.row1
      this.attachedPackRow = data.row2
      this.formPackGroup.package_id_list = this.attachedPackRow.map(s => s.id)
    },

    async updateAttachedPack(rows1, rows2) {
      this.unAttachedPackRow = rows1
      this.attachedPackRow = rows2
      this.formPackGroup.package_id_list = this.attachedPackRow?.map(
        item => item.id
      )
    },

    async addPackageGroup() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return

      this.formPackGroup.package_id_list = this.attachedPackRow.map(s => s.id)
      try {
        const resData = await addPackageGroupApi(this.formPackGroup)
        this.dialogFormVisible = false
        this.$message({
          type: 'success',
          message: this.$t('successMsg.' + resData.message)
        })
        this.attachData()
      } catch (err) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.' + err.response.data.message)
        })
      }
    },
    async updatePackageGroup() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      this.formPackGroup.package_id_list = this.attachedPackRow.map(s => s.id)
      try {
        const resData = await updatePackageGroupApi(this.formPackGroup)
        this.dialogFormVisible = false
        this.$message({
          type: 'success',
          message: this.$t('successMsg.' + resData.message)
        })
        this.attachData()
      } catch (err) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.' + err.response.data.message)
        })
      }
    },

    async deletePackageGroup() {
      const rowsSelected = this.packageGridApi.getSelectedRows()
      if (!rowsSelected?.length) {
        this.$message({
          message: this.$t('errorMsg.selectPackGroup'),
          type: 'error'
        })
      } else {
        const id_list = rowsSelected.map(item => item.id)
        this.$vxConfirm(this.$t('alert.deletePackGroup'), {
          resolveText: 'OK',
          rejectText: 'Cancel',
          resolve: () => {
            deletePackageGroupApi({
              id_list: id_list
            })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('successMsg.' + res.message)
                })
                this.attachData()
              })
              .catch(err => {
                this.$message({
                  type: 'error',
                  message: this.$t('errorMsg.' + err.response.data.message)
                })
              })
          }
        })
      }
    },

    async onDoubleClicked(rowSelected) {
      this.isEditDialog = true
      this.formPackGroup = { ...this.formPackGroup, ...rowSelected[0] }
      await this.getPackageList()
      this.attachedPackRow = [...rowSelected[0].packages]
      this.unAttachedPackRow = [
        ...this.unAttachedPackRow.filter(
          item => !rowSelected[0].packages.some(d => d.id === item.id)
        )
      ]
      this.dialogFormVisible = true
    },
    onSelectPackageGroup(row) {
      this.packageRows = row?.length == 1 ? row[0].packages : []
    },

    // DIALOG
    fnOpenAddDialog() {
      this.isEditDialog = false
      this.dialogFormVisible = true
      // this.getPackageList()
    },

    fnOpenEditDialog() {
      const rowsSelected = this.packageGridApi.getSelectedRows()

      if (!rowsSelected?.length) {
        this.$message({
          message: this.$t('errorMsg.selectPackGroup'),
          type: 'error'
        })
      } else if (rowsSelected.length !== 1) {
        this.$message({
          message: this.$t('errorMsg.selectOnlyOnePackGroup'),
          type: 'error'
        })
      } else {
        getPackageGroupDetailApi({ id: rowsSelected[0].id }).then(res => {
          this.formPackGroup = assignObjectFields(res.data, [
            'id',
            'code',
            'name',
            'description',
            'sold_individually',
            'active',
            'room_level_ids',
            'ticket_type_id',
            'max_apply_people',
            'min_apply_people'
          ])
        })
        this.getPackageList({ isAttachPack: true })
        this.isEditDialog = true
        this.dialogFormVisible = true
      }
    },

    fnCancelDialog() {
      this.dialogFormVisible = false

      // this.$vxConfirm(
      //   'Dữ liệu bạn điền chưa được lưu. Bạn chắc chắn muốn thoát không?',
      //   {
      //     resolveText: 'OK',
      //     rejectText: 'Cancel',
      //     resolve: () => {
      //       this.dialogFormVisible = false
      //     }
      //   }
      // )
    },

    getDefaultFormPackGroup() {
      return {
        id: null,
        code: '',
        name: '',
        description: '',
        sold_individually: true,
        active: true,
        package_id_list: [],
        max_apply_people: null,
        min_apply_people: null
      }
    },

    async resetPackGroupDialog() {
      this.formPackGroup = this.getDefaultFormPackGroup()
      this.packageSearchParams = { keyword: null }
      this.attachedPackRow = []
      this.multiGridTransKey++
      await this.getPackageList({ isAttachPack: false })
    },

    async fnGetRoomLevelOptions() {
      const resData = await getAllRoomLevelApi()
      this.roomLevelOptions = [...resData.data]
    },
    async fnGetTicketTypeOptions() {
      const resData = await getTicketTypeApi({ isCombo: true })
      this.ticketTypeOptions = [...resData.data]
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
